export const carouselLoop = (value: number, length: number) => {
  if (value < 0) {
    return length - 1;
  } else if (value === length) {
    return 0;
  } else {
    return value;
  }
};
